<template>
  <div id="metadata-container" class="ui container">
    <page-navigation-component></page-navigation-component>
    <div class="table-headers" v-if="0 < getObservationsCount">
      <div class="table-header" style="width: 100px; margin-left:40px;">Producer</div>
      <div class="table-header" style="width: 150px;">Station</div>
      <div class="table-header" style="width: 175px;">Dataset</div>
      <div class="table-header" style="width: 350px;">Variable (unit)</div> 
    </div>
    <div id="observation-list">
      <div v-for="(obs,index) in getObservations" v-bind:key="index">
        <observation-metadata-layout-component
          :id="obs.documentId"
          :observation="obs"
          class="ui content message table-row"
          @click.native="metaObsClicked($event)"
          style="padding:5px;"
        ></observation-metadata-layout-component>
      </div>
    </div>
  </div>
</template>

<style>
#metadata-container {
  position: absolute;
  bottom: 0;
  right: 40px;
  width: calc(70% - 40px);
  height: 50%;
  padding: 0px 5px 0px 5px;
  background-color: rgba(52,112,101,0.05);
  border-top-style: solid;
  border-top-width: 1px;
  border-color: grey;
  
}
#observation-list {
  position: relative;
  height: calc(90% - 50px);
  overflow: auto;
  clear: left;
}
#observation-list .content:hover {
  background-color: aquamarine;
}

.table-header {
  float:left;
  width: 150px;
  margin: 5px 10px 5px 0px;
  font-weight: bold;
}

.table-row {
  height: 30px;
  padding:5px;
}



</style>

<script>
import { mapGetters } from "vuex";
import observationMetadataLayoutComponent from "./observation-metadata-layout-component.vue";
import pageNavigationComponent from "./page-navigation-component.vue";

/**
 * This component create sub-component to print lite information about observation queried. Those observations
 * are paginated by the backend. Page controlling is managed by the pageNavigationComponent
 */
export default {
  components: {
    observationMetadataLayoutComponent,
    pageNavigationComponent
  },
  computed: {
    ...mapGetters(["getObservations", "getObservationsCount"])
  },
  methods: {
    /**
     * Method triggered on "click" on observationMetadataLayoutComponent. This method
     * fire "meta-obs-clicked" event that will triggerZoomInObs function of MapComponent
     * ---------------------------
     * This pattern firing event through component taht are not parent related is called event bus.
     * I suggest to not reproduce it too much for code readability and synchronicity. Prefer using 
     * Vuex store.
     */
    metaObsClicked(event) {
      let currentTarget = event.currentTarget;
      this.$root.$emit("meta-obs-clicked", currentTarget.id);
    }
  }
};
</script>
